var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3982 0C67.3982 0 76.2325 21.6125 38.3703 36.1295C17.7968 44.0155 1.99519 64.2279 20.8623 95.4511C22.4248 81.4949 29.1248 50.7231 57.9341 43.7013C57.9341 43.7013 31.1201 53.7278 28.7515 99.1135C42.5296 101.048 74.8434 102.348 84.4372 74.3058C97.1059 37.256 67.3982 0 67.3982 0Z",
    fill: "#3A7F0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.764 98.9247C58.0138 87.2512 79.2967 59.9046 82.234 27.2593C76.2544 11.1296 67.3982 0 67.3982 0C67.3982 0 76.2325 21.6125 38.3703 36.1295C17.7968 44.0155 1.99519 64.2279 20.8623 95.4511C22.4248 81.4949 29.1248 50.7231 57.9341 43.7013C57.9325 43.7015 31.1983 53.703 28.764 98.9247Z",
    fill: "#49A010"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9439 36.85C19.4541 36.85 20.6784 35.6257 20.6784 34.1155C20.6784 32.6054 19.4541 31.3811 17.9439 31.3811C16.4337 31.3811 15.2095 32.6054 15.2095 34.1155C15.2095 35.6257 16.4337 36.85 17.9439 36.85Z",
    fill: "#3A7F0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5376 33.3341C27.6162 33.3341 28.4906 32.4597 28.4906 31.3811C28.4906 30.3024 27.6162 29.428 26.5376 29.428C25.4589 29.428 24.5845 30.3024 24.5845 31.3811C24.5845 32.4597 25.4589 33.3341 26.5376 33.3341Z",
    fill: "#49A010"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7797 17.7093C27.4763 17.7093 29.6624 15.5232 29.6624 12.8266C29.6624 10.1299 27.4763 7.94385 24.7797 7.94385C22.083 7.94385 19.897 10.1299 19.897 12.8266C19.897 15.5232 22.083 17.7093 24.7797 17.7093Z",
    fill: "#49A010"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8189 25.5218C40.6818 25.5218 41.3814 24.8222 41.3814 23.9593C41.3814 23.0963 40.6818 22.3968 39.8189 22.3968C38.9559 22.3968 38.2563 23.0963 38.2563 23.9593C38.2563 24.8222 38.9559 25.5218 39.8189 25.5218Z",
    fill: "#49A010"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9062 19.6624C55.3871 19.6624 57.3983 17.6512 57.3983 15.1702C57.3983 12.6893 55.3871 10.6781 52.9062 10.6781C50.4253 10.6781 48.4141 12.6893 48.4141 15.1702C48.4141 17.6512 50.4253 19.6624 52.9062 19.6624Z",
    fill: "#49A010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.81b725d81c3685992a2b695608686891.svg";
export { ForwardRef as ReactComponent };